import type {
  GameModeData,
  GameModesTableColumns
} from '@library/types/gameModes';
import { getAllowedStatesLinks, getGameModeLinks } from '@bo-utils/gameModes';
import type { TableColumn } from '@library/types/utils';

export const GAME_MODES_TABLE_HEADER: Array<
  TableColumn<GameModesTableColumns>
> = [
  {
    column: 'checkbox',
    essential: true,
    label: '',
    sortEnabled: false,
    width: 'w-[3%] px-3'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true,
    width: 'w-[5%] px-3'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-[20%] px-3'
  },
  {
    column: 'game_types',
    essential: true,
    label: 'Game Types',
    sortEnabled: false,
    width: 'w-[25%] px-3',
    link: true,
    getLinks: getGameModeLinks
  },
  {
    column: 'allowed_states',
    essential: true,
    label: 'Allowed States',
    sortEnabled: false,
    width: 'w-[25%] px-3',
    link: true,
    getLinks: getAllowedStatesLinks
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: true,
    width: 'w-[14%] px-3'
  },
  {
    column: 'updated_at',
    essential: true,
    label: 'Updated At',
    sortEnabled: true,
    width: 'w-[14%] px-3'
  }
];

export const DEFAULT_GAME_MODE_DATA: GameModeData = {
  id: '',
  name: '',
  allowedStates: [],
  gameTypes: [],
  createdAt: '',
  updatedAt: ''
};
